module.exports = __webpack_public_path__ + "img/长方形1.248df08c.jpg";